class DialogWrapper {

    private isNativeCloseEvent = true;
    private animationEndCallback = this.animationEnd.bind(this);
    private config: { isEditMode: boolean } = { isEditMode: false };

    constructor(private dialog: HTMLDialogElement) {
        this.init();
    }

    private init() {
        this.dialog.addEventListener('cancel', (e) => {
            if (this.isNativeCloseEvent) {
                e.preventDefault();
                this.close();
            } else if(this.dialog.classList.contains('closing')) {
                this.finalizeClose();
            }
        });

        const closers = this.dialog.querySelectorAll('[data-close]');
        Array.from(closers).forEach(closer => {
            closer.addEventListener('click', () => {
                this.close();
            });
        });

        this.updateBasedOnConfig();

        this.dialog['hsm-wrapper'] = this;
    }

    public close(): void {
        this.isNativeCloseEvent = false;
        this.dialog.classList.add('closing');
        this.dialog.addEventListener('animationend', this.animationEndCallback, { once: true });
    }

    public open(data: { [key: string]: any }, config?: { isEditMode: boolean }) {
        console.log(data);
        for (const [key, value] of Object.entries(data)) {
            const input = this.dialog.querySelector<HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement>(`[name="${key}"]`);
            if (input && (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA')) {
                input.value = value;
                console.log(key, value)
            } else if (input && input.tagName === 'SELECT') {
                const select = (<HTMLSelectElement>input);
                console.log(key, value, select);
                select.selectedIndex = Array.from(select.options).findIndex(x => x.value === value);
            }
        }

        if (config) {
            this.config = config;
        }

        this.updateBasedOnConfig();

        this.dialog.showModal();
    }

    public updateBasedOnConfig() {
        this.dialog.querySelectorAll<HTMLElement>('[data-is-edit-mode]').forEach(x => {
            if (x.dataset.isEditMode === this.config.isEditMode.toString()) {
                x.classList.remove('hidden');
            } else {
                x.classList.add('hidden');
            }
        });
    }

    private finalizeClose(): void {
        this.dialog.classList.remove('closing');
        this.isNativeCloseEvent = true;
        this.dialog.removeEventListener('animationend', this.animationEndCallback, <AddEventListenerOptions>{ once: true });
        const forms = this.dialog.querySelectorAll('form');
        Array.from(forms).forEach(form => {
            form.reset();
            form.querySelectorAll('.field-validation-error').forEach(x => {
                x.innerHTML = '';
                x.classList.remove('field-validation-error');
                x.classList.add('field-validation-valid');
            });
            form.querySelectorAll('textarea').forEach(x => x.value = '');
            form.querySelectorAll<HTMLInputElement>('input').forEach(x => {
                if (x.name && x.name[0] === '_') {
                    return;
                }

                x.value = '';
            });

            form.querySelectorAll<HTMLSelectElement>('select').forEach(x => {
                x.selectedIndex = 0;
            });
        });

        this.config = { isEditMode: false };
        this.updateBasedOnConfig();
    }

    private animationEnd() {
        this.dialog.close();
        this.finalizeClose();
    }
}

export function initDialogs() {
    initDialog('dialog');
}

export function initDialog(selector: string) {
    const dialogs = document.querySelectorAll<HTMLDialogElement>(selector);
    Array.from(dialogs).forEach(dialog => {
        const wrapper = new DialogWrapper(dialog);

        if (dialog.id) {
            const triggers = document.querySelectorAll(`[data-dialog=${dialog.id}]`);
            Array.from(triggers).forEach(trigger => {
                trigger.addEventListener('click', () => {
                    dialog.showModal();
                });
            });
        }
    });
}